import { ButtonProps } from "@ds-developer/button/dist/types";
import { makeStyles } from "@material-ui/core";
import Button from "@ds-developer/button";
import React from "react";
import clsx from "clsx";

type Props = ButtonProps & {
  brand?: string | undefined;
  onClickHandler: () => unknown;
  label: string;
  buttonCancel?: boolean;
};

const useStyles = makeStyles(() => ({
  button: {
    width: "134px",
    height: "48px",
    borderRadius: "5px",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "48px",
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    textTransform: "inherit",
  },
  buttonBsm: {
    background: "#F9812A",
    color: "#FFFFFF",
    textTransform: "none",
    "&:hover": {
      background: "#F9812A",
      color: "#FFFFFF",
    },
  },
  buttonAa: {
    background: "#FFCC00",
    color: "#000000",
    textTransform: "none",
    "&:hover": {
      background: "linear-gradient(0deg, #FFD800, #FFD800), #FFCC00",
      color: "#000000",
    },
  },
  buttonCancel: {
    width: "106px",
    background: "#FFFFFF",
    color: "#1D1D1D",
    border: "2px solid #1D1D1D",
    textTransform: "none",
    "&:hover": {
      background: "#c7c8ca66",
    },
    "&[data-attr-brand='bsm']": {
      color: "#3933B7",
      border: "unset",
      boxShadow:
        "0px 1px 1px rgba(79, 74, 201, 0.05), 0px 4px 8px rgba(79, 74, 201, 0.1)",
    },
  },
}));

const ButtonCTA: React.FC<Props> = props => {
  const classes = useStyles();
  return (
    <Button
      {...props}
      onClick={props.onClickHandler}
      className={clsx(classes.button, {
        [classes.buttonBsm]: props.brand === "BSM",
        [classes.buttonAa]: props.brand !== "BSM",
        [classes.buttonCancel]: props.buttonCancel,
      })}
      data-attr-brand={props.brand?.toLowerCase()}
    >
      {props.label}
    </Button>
  );
};

export default ButtonCTA;
